import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormControlLabel, Switch, InputLabel } from '@material-ui/core'

const FormSwitchField = ({ formActions, classes, name, labelKey, label, noLabel, required, row, disabled, labelPrefix, switchLabel, flip }) => {
  const intl = useIntl()
  let newClasses = [
    !!row ? classes.FormRow : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      {!noLabel && <InputLabel htmlFor={name}>{label ?? <FormattedMessage id={labelKey}/>}{!!required &&
      <span className={'required'}>*</span>}:</InputLabel>}
      <FormControlLabel
        control={
          <Switch
            checked={!!flip? !formActions.values[name] : formActions.values[name]}
            onChange={(event) => {
                formActions.setFieldValue(name, !!flip? !event.target.checked : !!event.target.checked)
            }}
            name={name}
            id={name}
            color="primary"
            disabled={disabled}
            onBlur={formActions.handleBlur}
            error={formActions.errors[name] && formActions.touched[name] !== undefined}
          />}
        label={intl.formatMessage({ id: switchLabel ?? `${labelPrefix}.${!!flip? !formActions.values[name] : !!formActions.values[name]}` })}
        labelPlacement="end"
      />
    </div>
  )
}

export default FormSwitchField
